import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import ModalContainer from "./ModalContainer";

class InfoPrivateHireModal extends Component {
    render() {
        return (
            <ModalContainer
                open={this.props.open}
                title={"In order to use Hot Giggity, you must enter payment details."}
                onClose={this.props.closeHandler}
                fullScreen={false}
                maxWidth={this.props.maxWidth ? this.props.maxWidth : "xs"}
            >
                <DialogContent>
                    <DialogContentText>{this.props.message}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={this.props.declineHandler ? this.props.declineHandler : this.props.closeHandler}>
                        Continue
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default InfoPrivateHireModal;
